import { Row } from "../row/row"
import { Spinner } from "./spinner"

export const CenteredSpinner = () => {
  return <Row justifyContent="center">
    <Spinner />
  </Row>
}